import React from 'react';
import type { TdsItem } from '../../../types/testDataCharts.types';

interface TestDataTableProps {
  tdsList: TdsItem[];
  numeratorName: string;
  denominatorName: string;
  valueName: string;
  outsideVarName: string;
}

/** Rounds value to 4 decimal places, matching legacy formatValueForDisplay. */
function formatValue(value: number): string {
  return (Math.round(value * 10000) / 10000).toString();
}

const TestDataTable: React.FC<TestDataTableProps> = ({
  tdsList,
  numeratorName,
  denominatorName,
  valueName,
  outsideVarName,
}) => {
  const resolvedOutsideVarName = outsideVarName.trim() === '' ? 'Other' : outsideVarName;

  return (
    <div className="overflow-x-auto w-full">
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="bg-blue-900 text-white">
            <th className="px-3 py-2 text-left font-semibold border border-blue-800 w-40">Test Of Change</th>
            <th className="px-3 py-2 text-left font-semibold border border-blue-800 w-28">Date Of Test</th>
            <th className="px-3 py-2 text-left font-semibold border border-blue-800 w-20">Shift</th>
            <th className="px-3 py-2 text-left font-semibold border border-blue-800">{numeratorName || 'Numerator'}</th>
            <th className="px-3 py-2 text-left font-semibold border border-blue-800">{denominatorName || 'Denominator'}</th>
            <th className="px-3 py-2 text-right font-semibold border border-blue-800">{valueName || 'Value'}</th>
            <th className="px-3 py-2 text-left font-semibold border border-blue-800 w-36">Notes</th>
            <th className="px-3 py-2 text-left font-semibold border border-blue-800">{resolvedOutsideVarName}</th>
          </tr>
        </thead>
        <tbody>
          {tdsList.map((item, idx) => (
            <tr
              key={item.tdsId}
              className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
            >
              <td className="px-3 py-2 border border-gray-200" title={item.testOfChange}>
                {item.testOfChange.length > 22
                  ? `${item.testOfChange.substring(0, 22)}…`
                  : item.testOfChange}
              </td>
              <td className="px-3 py-2 border border-gray-200">{item.testDate}</td>
              <td className="px-3 py-2 border border-gray-200">{item.shiftDesc}</td>
              <td className="px-3 py-2 border border-gray-200">{item.numeratorValue}</td>
              <td className="px-3 py-2 border border-gray-200">{item.denominatorValue}</td>
              <td className="px-3 py-2 border border-gray-200 text-right">{formatValue(item.value)}</td>
              <td className="px-3 py-2 border border-gray-200">{item.notes ?? ''}</td>
              <td className="px-3 py-2 border border-gray-200">{item.outsideVarValue ?? ''}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TestDataTable;
